// ◉ xlVISION · Powering Business Together!
// © ExcelVision, Lda. — Braga, Portugal
// ( ·:·●●·:· ) xlVISION | Powering Business Together!
//
// ============================================================================
// 🔴 2026-10-23 · D-101 · O INÍCIO DA FITA DESTE ECRÃ — que toda a escrita leva
// ============================================================================
//
// O servidor confere-o (`apps/api/src/janela-da-escrita.ts`) e recusa com 409 se a fita mudou
// entretanto — sem isto, uma reserva preparada antes da viragem do mês gravava datas com um mês de
// diferença. ⚠️ Quem o PÕE no pedido é o invólucro único do `fetch` (`mapa/ancora.ts`): um segundo
// invólucro era uma segunda cópia do `fetch`, que `ancora-viaja.test.ts` recusa — e com razão.
// ⚠️ É diferente da âncora: o conflito da âncora pode ser ACEITE e repetido; uma fita que mudou de
//    início não — os mesmos números de dia passaram a ser outras datas.
// ============================================================================

import { hojeEmPortugal, indiceDaData, janelaContinua, type JanelaDoMapa } from '@xlv-gva-mpt/dominio';

export const CABECALHO_DA_JANELA = 'x-mpt-janela';

let inicioDaFita: string | null = null;
let diasDaFita = 0;

/** Chamado quando os dados do mapa chegam (`DadosMapa.inicio` e `nDias`). */
export function definirInicioDaFita(inicio: string | null | undefined, nDias = 0): void {
  inicioDaFita = inicio === undefined || inicio === null || inicio.trim() === '' ? null : inicio;
  diasDaFita = inicioDaFita === null ? 0 : nDias;
}

/**
 * 🔴 D-101 · A janela inteira do ecrã, para quem não recebe os `dados` (ex.: as datas de um pedido
 * abertas a partir da lista). `null` antes de o mapa chegar — e aí quem chama decide a omissão.
 */
export function janelaDoEcraActual(): JanelaDoMapa | null {
  return inicioDaFita === null ? null : { inicio: inicioDaFita, nDias: diasDaFita };
}

/** O início da fita em vigor, ou `null` antes de o mapa chegar. */
export function inicioDaFitaActual(): string | null {
  return inicioDaFita;
}

/**
 * `AAAA-MM-DD` → o índice na fita deste ecrã (o espaço de `dia0`/`dia1`), ou `null` antes de o mapa
 * chegar. ⚠️ Para quem não recebe os `dados` (ex.: a lista de pedidos) — uma conta à mão com o ano
 * da própria data punha os dias de Janeiro no princípio da fita.
 */
export function indiceNaFitaDoEcra(isoData: string): number | null {
  // A janela só precisa do início para converter; `nDias` não entra na conta.
  return inicioDaFita === null ? null : indiceDaData({ inicio: inicioDaFita, nDias: 0 }, isoData);
}

/**
 * 🔴 2026-10-30 · Pedido 1 · A fita com que se LÊ um índice de dia que veio do servidor, para o dizer
 * pela data: a deste ecrã (a que o pedido levou no cabeçalho) ou, antes de o mapa chegar, a de hoje
 * — que é a que o servidor usa sem cabeçalho. Quem tem os `dados` usa-os directamente.
 */
export function janelaParaLer(): JanelaDoMapa {
  return janelaDoEcraActual() ?? janelaContinua(hojeEmPortugal());
}
